import { render, staticRenderFns } from "./Hot.vue?vue&type=template&id=0950d46e&"
import script from "./Hot.vue?vue&type=script&lang=js&"
export * from "./Hot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports